import React, { useState, useEffect } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

const WorkWaysSection = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loaded, setLoaded] = useState(false);

    const ways = [
        {
            number: '01',
            subtitle: 'Want to understand more?',
            title: 'Process Data Audit',
            description: 'Start with a Process Data Audit — Mobikode reviews your process data and walks you through the benefits of process data analytics for your specific plant, with hands-on discussion and training for your team.'
        },
        {
            number: '02',
            subtitle: 'Want to update often?',
            title: 'Want to update often?',
            description: 'We provide dynamic update solutions that allow your systems to stay current with the latest operational parameters without requiring full system overhauls or downtime.'
        },
        {
            number: '03',
            subtitle: 'Want to use it regularly?',
            title: 'Product',
            description: 'Our flagship product designed for everyday industrial use. It integrates directly into your workflow to provide real-time insights and automated reporting for your entire engineering team.'
        }
    ];

    const [sliderRef, instanceRef] = useKeenSlider(
        {
            initial: 0,
            loop: true,
            centered: true,
            slides: {
                perView: 1.2,
                spacing: 15,
            },
            breakpoints: {
                '(min-width: 1024px)': {
                    slides: { perView: 2.8, spacing: 30 },
                },
            },
            slideChanged(slider) {
                setCurrentSlide(slider.track.details.rel);
            },
            created() {
                setLoaded(true);
            },
        },
        [
            (slider) => {
                let timeout;
                let mouseOver = false;
                function clearNextTimeout() {
                    clearTimeout(timeout);
                }
                function nextTimeout() {
                    clearTimeout(timeout);
                    if (mouseOver) return;
                    timeout = setTimeout(() => {
                        slider.next();
                    }, 3000);
                }
                slider.on('created', () => {
                    slider.container.addEventListener('mouseover', () => {
                        mouseOver = true;
                        clearNextTimeout();
                    });
                    slider.container.addEventListener('mouseout', () => {
                        mouseOver = false;
                        nextTimeout();
                    });
                    nextTimeout();
                });
                slider.on('dragStarted', clearNextTimeout);
                slider.on('animationEnded', nextTimeout);
                slider.on('updated', nextTimeout);
            },
        ]
    );

    return (
        <section className="w-full bg-white py-16 lg:py-24 overflow-hidden select-none">
            <div className="max-w-[1440px] w-full mx-auto px-6 lg:px-16 flex flex-col items-center">

                <h2 className="text-[20px] sm:text-[30px] font-sora font-[600] text-[#01386A] tracking-tight mb-16 text-center">
                    Three Ways to Work With Us
                </h2>

                <div ref={sliderRef} className="keen-slider flex items-center !overflow-visible">
                    {ways.map((way, index) => {
                        const isActive = currentSlide === index;
                        return (
                            <div
                                key={index}
                                onClick={() => instanceRef.current?.moveToIdx(index)}
                                className="keen-slider__slide !overflow-visible flex items-center justify-center cursor-pointer"
                            >
                                <div
                                    className={`relative w-full max-w-[420px] transition-all duration-500 ease-in-out flex flex-col p-6 lg:p-8 h-[340px] sm:h-[300px] lg:h-[360px] border-t border-x ${isActive
                                        ? 'bg-[#01386A] text-white border-[#01386A] scale-105 z-20 shadow-xl translate-y-0'
                                        : 'bg-white text-[#01386A] border-[#01386A45] scale-95 z-10 opacity-50 translate-y-2'
                                        }`}
                                >
                                    <div className="flex items-start gap-3 mb-4">
                                        <span className={`text-[20px] lg:text-[30px] font-sora font-[600] leading-none ${isActive ? 'text-white' : 'text-[#01386A]'}`}>
                                            {way.number}
                                        </span>
                                        <div className="flex flex-col mt-1">
                                            <span className={`text-[14px] lg:text-[16px] font-graphik font-[500] mb-0.5 ${isActive ? 'text-gray-200' : 'text-[#49577A]'}`}>
                                                {way.subtitle}
                                            </span>
                                            <h3 className={`text-[16px] lg:text-[20px] font-sora font-[600] leading-tight ${isActive ? 'text-white' : 'text-[#01386A]'}`}>
                                                {way.title}
                                            </h3>
                                        </div>
                                    </div>

                                    <p className={`text-[14px] lg:text-[16px] font-graphik font-[500] leading-relaxed overflow-y-auto mb-2 ${isActive ? 'text-gray-200' : 'text-[#49577A]'}`}>
                                        {way.description}
                                    </p>

                                    <div className={`absolute bottom-0 left-0 w-full h-[5px] ${isActive ? 'bg-orange-500' : 'bg-[#01386A]'}`} />
                                </div>
                            </div>
                        );
                    })}
                </div>

                {loaded && instanceRef.current && (
                    <div className="flex items-center gap-2 mt-12">
                        {[...Array(instanceRef.current.track.details.slides.length).keys()].map((idx) => {
                            return (
                                <button
                                    key={idx}
                                    onClick={() => instanceRef.current?.moveToIdx(idx)}
                                    className={`w-2.5 h-3 rounded-full transition-all duration-300 ${currentSlide === idx ? 'bg-[#01386A] w-5' : 'bg-gray-300'
                                        }`}
                                />
                            );
                        })}
                    </div>
                )}

            </div>
        </section>
    );
};

export default WorkWaysSection;